import { createStore } from 'owa-satcheljs';
import type { AccountKey } from 'owa-client-types';
import type { BizChatCompositeKey } from 'owa-bizchat-types';

// Copied from https://office.visualstudio.com/Office/_git/1JS?path=/midgard/packages/msb-cib/src/Utils/hostUtils.ts
export enum UserCohort {
    Unknown = 'unknown',
    None = 'none',
    BCAIS = 'bcais', // BizChat - AI SKU users
    BCWAF = 'bcwaf', // BizChat Web - All Features
    BCWBF = 'bcwbf',
}

interface BizchatSidepaneEnabledSettings {
    hasAcquisition: boolean;
    userCohort: UserCohort;
    isCopilotEligible: boolean;
}

interface BizchatSidepaneSharedStore {
    // < key: Coprincipal Account Identifier, value: Whether Bizchat Sidepane is enabled for the mailbox >
    hasBizchatAcquisitionMap: Map<AccountKey, BizchatSidepaneEnabledSettings>;
    isBizchatSidepaneLoadedMap: Map<BizChatCompositeKey, boolean>;
}

export const bizchatSidepaneSharedStore: () => BizchatSidepaneSharedStore =
    createStore<BizchatSidepaneSharedStore>('BizchatSidepaneSharedStore', {
        hasBizchatAcquisitionMap: new Map<AccountKey, BizchatSidepaneEnabledSettings>(),
        isBizchatSidepaneLoadedMap: new Map<BizChatCompositeKey, boolean>(),
    });
